import { ApiService, ApiServiceInterface } from "../../../../../core";
import { PhoneNumber, ProductDataResponse, ProductPageController, RequestPhoneResponse } from "../../core";

export class ProductPageControllerImpl implements ProductPageController {
    private api: ApiServiceInterface;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(productUrl: string): Promise<ProductDataResponse> {
        try {
            const response = await this.api.get(`/product/${productUrl}`);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async requestPhoneNumber(carPartId: string): Promise<PhoneNumber> {
        try {
            const formData = new FormData();
            formData.append('carPartId', carPartId);
            const response: RequestPhoneResponse = await this.api.post('/engagement-request', formData);
            return response.response;
        } catch (error) {
            throw new Error("Unknown error.");
        }
    }
}